export default function JogevaGreeting() {
    return (
      <div>
        <h1>Jögeva!</h1>
      </div>
    );
  }